import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationEN from './translations/en.json'
import translationES from './translations/es.json'

import NumberUtils from '../../utils/number'

// the translations
const resources = {
    en: {
        translation: translationEN,
        name: 'English (UK)',
    },
    es: {
        translation: translationES,
        name: 'Español',
    },
}

i18n.use(initReactI18next).init({
    resources,
    lng: 'en',

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
        escapeValue: false, // react already safes from xss
        format: (value, format) => {
            switch (format) {
                case 'decimals':
                    return NumberUtils.withDecimalsIfNeeded(value)
                default:
                    return value
            }
        },
    },
})

export default i18n
